export default "__VITE_ASSET__0de7ee83__"